import { createApi } from '@reduxjs/toolkit/query/react';
import { cloudlabBaseQueryWithEncryption } from './cloudlabBaseQuery';

export const cloudlabApi = createApi({
    reducerPath: 'cloudlabApi',
    baseQuery: cloudlabBaseQueryWithEncryption,
    tagTypes: ['Instance', 'Template'],
    endpoints: (builder) => ({
        // Add cloudlab endpoints here:
        //GET /fetch-user
        getUserDetails: builder.query({
            query: (payload) => ({
                url: '/lab/fetch-user',
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${payload?.token}`,
                },
            })
        }),

        // Add Instance Management endpoints here:

        //GET /lab/envs
        getInstances: builder.query({
            query: () => ({
                url: 'lab/envs',
                method: 'GET',
            }),
            providesTags: ['Instance'],
        }),

        //PATCH /lab/envs/{envName}
        updateInstance: builder.mutation({
            query: (envName) => ({
                url: `lab/envs/${envName}`,
                method: 'PATCH',
            }),
            invalidatesTags: ['Instance'],
        }),

        //GET /lab/server-envs/{envName}
        fetchServerInstance: builder.mutation({
            query: (envName) => ({
                url: `lab/server-envs/${envName}`,
                method: 'GET',
            }),
            providesTags: ['Instance'],
        }),

        //DELETE /lab/envs/{envName}
        deleteEnvironment: builder.mutation({
            query: (envId) => ({
                url: `lab/envs/${envId}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Instance'],
        }),

        //PUT /lab/envs/{envId}/restart
        startEnvironment: builder.mutation({
            query: (envId) => ({
                url: `lab/envs/${envId}/restart`,
                method: 'PUT',
            }),
            invalidatesTags: ['Instance'],
        }),

        //PUT /lab/envs/{envId}/stop
        stopEnvironment: builder.mutation({
            query: (envId) => ({
                url: `lab/envs/${envId}/stop`,
                method: 'PUT',
            }),
            invalidatesTags: ['Instance'],
        }),

        // Add Template Management endpoints here:

        //GET /lab/templates
        getTemplates: builder.query({
            query: () => ({
                url: 'lab/templates',
                method: 'GET',
            }),
            providesTags: ['Template'],
        }),

        //POST /lab/envs
        createEnvironment: builder.mutation({
            query: (data) => {
                return {
                    url: 'lab/envs',
                    method: 'POST',
                    body: {
                        templateId: data.templateId,
                        inputs: data.inputs,
                    },
                }
            },
            invalidatesTags: ['Instance', 'Template']
        })
    })
});

export const {
    useGetInstancesQuery,
    useUpdateInstanceMutation,
    useFetchServerInstanceMutation,
    useDeleteEnvironmentMutation,
    useGetTemplatesQuery,
    useCreateEnvironmentMutation,
    useGetUserDetailsQuery,
    useStartEnvironmentMutation,
    useStopEnvironmentMutation,
} = cloudlabApi;